// consts
import { emailPattern } from "../config/const";
import userService from "../services/user.service";

export const validateForm = ({
  firstName = null,
  lastName = null,
  email = null,
  phoneNumber = null,
  specialty = null,
  graduation = null,
  position = null,
  jersey = null,
  group = null,
  schoolName = null,
  schoolType = null,
  sport = null,
  country = null,
  plan = null,
  status = null,
  stateid = null,
  password = null,
  confirmPassword = null,
  eventName = null,
  eventDate = null,
  eventTime = null,
  location = null,
  eventDescription = null,
  teamName = null,
  eventType = null,
  team1Id = null,
  team2Id = null,
  category = null,
  eventId = null,
  playlistName = null,
  groupName = null,
  sportsName = null,
  groupIds,
  editGroupIds,
  editSportsName = null,
  selectedValues,
}) => {
  let errors = {};
  let formIsValid = true;

  if (firstName !== null && !firstName) {
    formIsValid = false;
    errors["firstName"] = "*Please enter first name.";
  }

  if (lastName !== null && !lastName) {
    formIsValid = false;
    errors["lastName"] = "*Please enter Last name.";
  }

  if (email !== null && !email) {
    formIsValid = false;
    errors["email"] = "*Please enter email-ID.";
  }

  if (email !== null && typeof email !== "undefined") {
    if (!emailPattern.test(email)) {
      formIsValid = false;
      errors["email"] = "*Please enter valid email-ID.";
    }
  }

  if (phoneNumber !== null && !phoneNumber) {
    formIsValid = false;
    errors["mobileno"] = "*Please enter mobile number.";
    errors["phoneNumber"] = "*Please enter mobile number.";
  }

  if (phoneNumber !== null && typeof phoneNumber !== "undefined") {
    if (!phoneNumber.match(/^[0-9-+() ]*$/)) {
      formIsValid = false;
      errors["mobileno"] = "*Please enter valid mobile number.";
      errors["phoneNumber"] = "*Please enter mobile number.";
    }
  }

  if (specialty !== null && !specialty) {
    formIsValid = false;
    errors["specialty"] = "*Please select specialty.";
  }
  if (graduation !== null && !graduation) {
    formIsValid = false;
    errors["graduation"] = "*Please enter graduation year.";
  }
  if (position !== null && !position) {
    formIsValid = false;
    errors["position"] = "*Please enter position.";
  }
  if (jersey !== null && !jersey) {
    formIsValid = false;
    errors["jersey"] = "*Please enter jersey number.";
  }
  if (group !== null && !group) {
    formIsValid = false;
    errors["group"] = "*Please enter group.";
  }
  if (schoolName !== null && !schoolName) {
    formIsValid = false;
    errors["schoolName"] = "*Please enter school name.";
  }

  if (schoolType !== null && !schoolType) {
    formIsValid = false;
    errors["schoolType"] = "*Please enter school type.";
  }

  if (sport !== null && !sport) {
    formIsValid = false;
    errors["sport"] = "*Please enter sport.";
  }
  if (country !== null && !country) {
    formIsValid = false;
    errors["country"] = "*Please enter country.";
  }

  if (plan !== null && !plan) {
    formIsValid = false;
    errors["plan"] = "*Please enter plan.";
  }
  if (status !== null && !status) {
    formIsValid = false;
    errors["status"] = "*Please enter status.";
  }

  if (stateid !== null && !stateid) {
    formIsValid = false;
    errors["state"] = "*Please enter state.";
  }

  if (password !== null && !password) {
    formIsValid = false;
    errors["password"] = "*Please enter password.";
  }

  if (
    password !== null &&
    confirmPassword !== null &&
    password !== confirmPassword
  ) {
    formIsValid = false;
    errors["confirmPassword"] =
      "*Please check password and confirm password fields not match.";
  }

  if (eventName !== null && !eventName) {
    formIsValid = false;
    errors["eventName"] = "*Please enter event name";
  }
  if (eventDate !== null && !eventDate) {
    formIsValid = false;
    errors["eventDate"] = "*Please select event date";
  }

  if (eventTime !== null && !eventTime) {
    formIsValid = false;
    errors["eventTime"] = "*Please enter event time.";
  }

  if (location !== null && !location) {
    formIsValid = false;
    errors["location"] = "*Please enter location.";
  }

  if (eventDescription !== null && !eventDescription) {
    formIsValid = false;
    errors["eventDescription"] = "*Please enter event Description.";
  }
  if (teamName !== null && !teamName) {
    formIsValid = false;
    errors["teamName"] = "*Please enter first name.";
  }
  if (eventType !== null && !eventType) {
    formIsValid = false;
    errors["eventType"] = "*Please add event type.";
  }

  if (team1Id !== null && !team1Id) {
    formIsValid = false;
    errors["team1Id"] = "*Please enter Team ID.";
  }
  if (team2Id !== null && !team2Id) {
    formIsValid = false;
    errors["team2Id"] = "*Please enter Team ID.";
  }

  if (team1Id !== null && team2Id !== null) {
    if (team1Id == team2Id) {
      formIsValid = false;
      errors["team1Id"] = "*Please select different Teams.";
      errors["team2Id"] = "*Please select different Teams.";
    }
  }

  if (category !== null && !category) {
    formIsValid = false;
    errors["category"] = "*Please select category.";
  }
  if (eventId !== null && !eventId) {
    formIsValid = false;
    errors["eventId"] = "*Please select an Event.";
  }
  if (playlistName !== null && !playlistName) {
    formIsValid = false;
    errors["playlistName"] = "*Please enter playlist name.";
  }
  if (groupName !== null && !groupName) {
    formIsValid = false;
    errors["groupName"] = "*Please enter group name.";
  }
  if (sportsName !== null && !sportsName) {
    formIsValid = false;
    errors["sportName"] = "*Please enter sport name.";
  }
  if (editSportsName !== null && !editSportsName) {
    formIsValid = false;
    errors["sportName"] = "*Please enter sport name.";
  }
  if (groupIds !== undefined && groupIds.length == 0) {
    formIsValid = false;
    errors["groupIds"] = "*Please select at least one playlevel";
  }
  if (editGroupIds !== undefined && editGroupIds.length == 0) {
    formIsValid = false;
    errors["groupIds"] = "*Please select at least one playlevel";
  }

  return {
    errors,
    formIsValid,
  };
};
